import "./index.css";
import "tiny-ui/dist/styles/index.css";
import { Link } from "react-router-dom";
import Footer from "./components/footer";
import Header from "./components/header";
import { useEffect, useState } from "react";
import axios from "axios";

function Landing() {
  const [count, setCount] = useState();

  const getSearchCount = () => {
    try {
      axios
        .get("https://westandwithgaza.com/api/getSearchCount")
        .then((res) => {
          setCount(res.data.count);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getSearchCount();
  }, [count]);

  return (
    <div className="bg-white min-h-screen flex flex-col">
      {/* Header */}
      <Header />

      {/* Image Section */}
      <section className="flex justify-center items-center">
        <img
          src="https://westandwithgaza.com/palestine.png"
          alt="palestine image"
          className="w-80 h-80 object-cover"
        />
      </section>

      {/* Large Text Section */}
      <section className="py-4 text-center mb-4 flex-1">
        <h2 className="text-4xl font-bold mb-4">Boycott Israel Products</h2>
        <p className="text-lg text-gray-600 mb-5">
          Scan products to show if it's supporting Israel.
        </p>
        <img
          src="https://westandwithgaza.com/barcode.svg"
          alt="palestine image"
          className="w-20 h-20 object-cover mx-auto mb-10"
        />
        <Link
          to="/scanner2"
          style={{ textDecoration: "none", color: "white" }}
          className="bg-black text-white text-2xl px-10 py-5 rounded hover:bg-gray-700"
        >
          Scan Product
        </Link>

        {count && (
          <div className="mt-20 text-gray-600 text-xl">
            Total Searchs: {count}
          </div>
        )}
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default Landing;
